import { Capacitor } from "@capacitor/core";
export const isIos = () => {
    return Capacitor.getPlatform() === "ios";
};
export const isAndroid = () => {
    return Capacitor.getPlatform() === "android";
};
//# sourceMappingURL=utils.js.map